module.exports = __webpack_public_path__ + "static/media/03-2-galeria-01-rimowa-mobile@2x.ca2af47c.jpg";